import React, { createContext, useContext, ReactNode } from "react";
import { useCalendar } from "@/contexts/CalendarContext";
import { useSelectedStaff } from "@/contexts/SelectedStaffContext";

interface CalendarDataContextType {
  // UI State only - data fetching is now handled by individual hooks
  currentDate: Date;
  selectedStaffId: number | null;
  setSelectedStaffId: (id: number | null) => void;
}

const CalendarDataContext = createContext<CalendarDataContextType | undefined>(undefined);

export function CalendarDataProvider({ children }: { children: ReactNode }) {
  // Get UI state from existing contexts
  const { currentDate } = useCalendar();
  const { selectedStaffId, setSelectedStaffId } = useSelectedStaff();

  const value: CalendarDataContextType = {
    currentDate,
    selectedStaffId,
    setSelectedStaffId,
  };

  return <CalendarDataContext.Provider value={value}>{children}</CalendarDataContext.Provider>;
}

// Hook for consuming context
export function useCalendarData() {
  const ctx = useContext(CalendarDataContext);
  if (!ctx) throw new Error("useCalendarData must be used within a CalendarDataProvider");
  return ctx;
}
